
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.687 6.315c-1.545-1.545-3.357-2.239-4.048-1.547-.213.212-.294.529-.26.909a4.868 4.868 0 01-.115.863L11.6 9.208a6.75 6.75 0 01-2.027.23c-.894-.278-1.647-.234-2.084.203-.968.969-.012 3.498 2.138 5.647 2.15 2.15 4.676 3.107 5.643 2.14.37-.37.459-.965.31-1.678l.007.008s-.153-1.23.227-2.485l2.51-2.512c.305-.076.64-.122 1.014-.134.375.028.685-.053.894-.262.691-.692-.001-2.504-1.545-4.05m-10.64 8.834L4.5 20.5l5.336-3.575a13.344 13.344 0 01-1.789-1.777","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    